import React from "react";

import { TopBar } from "./top-bar";
import { NavBar } from "./nav-bar";

// Common wrapper for navigation. We could add OffcanvasMenu, Navbar etc components here.

const HeaderBase = () =>{
  return (
    <div className="">
      <TopBar />
      <NavBar />
    </div>
)
};
const Header = HeaderBase;
export { Header };
